const STATE_COLLAPSED = 'false';
const STATE_EXPANDED = 'true';
const ARIA_EXPANDED_ATTRIBUTE = 'aria-expanded';
const DATA_EXPANDED_ATTRIBUTE = 'data-expanded';
const DATA_INITIALIZED_ATTRIBUTE = 'data-collection-description-initialized';

const updateToggleState = (containerEl, toggleEl, isExpanded) => {
  const expandedValue = isExpanded
    ? STATE_EXPANDED
    : STATE_COLLAPSED;

  containerEl.setAttribute(DATA_EXPANDED_ATTRIBUTE, expandedValue);
  toggleEl.setAttribute(ARIA_EXPANDED_ATTRIBUTE, expandedValue);
  toggleEl.textContent = isExpanded
    ? toggleEl.dataset.readLessLabel
    : toggleEl.dataset.readMoreLabel;
};

const initCollectionHeader = () => {
  const containerEl = document.querySelector('[data-collection-description]');
  if (!containerEl) return;

  const toggleEl = containerEl.querySelector('[data-collection-description-toggle]');
  if (!toggleEl) return;
  if (toggleEl.hasAttribute(DATA_INITIALIZED_ATTRIBUTE)) return;

  toggleEl.setAttribute(DATA_INITIALIZED_ATTRIBUTE, STATE_EXPANDED);
  updateToggleState(containerEl, toggleEl, false);

  toggleEl.addEventListener('click', () => {
    const currentState = containerEl.getAttribute(DATA_EXPANDED_ATTRIBUTE);
    const isExpanded = currentState !== STATE_EXPANDED;
    updateToggleState(containerEl, toggleEl, isExpanded);
  });
};

export default initCollectionHeader;
